//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectFace.js";
import "../no/SelectTaggedObject.js";
import "../Features/Features.ShipDesign.SteelFeatureSpreadsheetBuilder.js";
import "../no/SelectObject.js";
import "../no/Features.js";
let d=[[[1,"CSYSTargetFace",0,"SelectFace",0],[0,"CoordinateSystem",1,"CoordinateSystem",0],[0,"CornerPoint",1,"Point",0],[1,"CornerTargetFace",0,"SelectFace",0],[1,"CurveTargetFace",0,"SelectFace",0],[0,"DistanceTolerance",1,0],[1,"GuideCurve",0,"SelectTaggedObject",0],[0,"PlacementType",1,0],[1,"Spreadsheet",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0]],[],[]];
SPLM.Features.ShipDesign.WeldCut2Builder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.WeldCut2Builder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.WeldCut2Builder.CreationMethod = Object.freeze({
    "Corner" : "Corner", "AlongGuide" : "AlongGuide", "SpecifyCSYS" : "SpecifyCSYS"});

export default SPLM;